import { translate } from './index';

/**
 * 서버/저장 데이터에 한국어로 들어 있는 라벨을 현재 언어로 보여준다.
 * (저장된 값은 바꾸지 않고 화면에 보여줄 때만 번역)
 */

/** 라운드 이름: 대진 크기와 라운드 순서로 만든다. 8강 대진 0 → 8강(Quarterfinals), 마지막 → 결승(Final) */
export function roundLabelFromSize(bracketSize, roundIndex) {
  const matchCount = Number(bracketSize) >> (Number(roundIndex) + 1);
  return matchCount <= 1 ? translate('common.round.final') : translate('common.round.ofN', { n: matchCount * 2 });
}

/** 서버가 준 한국어 라운드 이름('결승', '8강') → 현재 언어 */
export function translateRoundLabel(label) {
  if (!label) return label;
  if (label === '결승') return translate('common.round.final');
  if (label === '1:1 경기') return translate('common.round.matchList');
  const match = /^(\d+)강$/.exec(label);
  return match ? translate('common.round.ofN', { n: match[1] }) : label;
}

/** 저장된 부문 이름('남자부', '여자부', '130~140cm') → 현재 언어 */
export function translateDivisionLabel(label) {
  if (!label) return label;
  if (label === '남자부') return translate('common.division.male');
  if (label === '여자부') return translate('common.division.female');
  return label;
}
